import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '/aigc-admin',
    name: 'AigcAdmin',
    component: () => import('@/layouts/main/index.vue'),
    redirect: '/aigc-admin/task-manage/list',
    meta: {
      title: 'AIGC服务台'
    },
    children: [
      {
        path: 'task-manage/list',
        name: 'AigcAdminTaskManageList',
        component: () => import('./task-manage/views/list/index.vue'),
        meta: {
          title: '任务管理',
          auth: true,
        },
      },
      {
        path: 'task-manage/detail/:id',
        name: 'AigcAdminTaskManageDetail',
        component: () => import('./task-manage/views/detail/index.vue'),
        meta: {
          title: '任务管理详情',
          auth: true,
        },
      },
    ],
  }
] as IRouteConfig[];
